import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "object-tree object-tree--container" }
const _hoisted_2 = { class: "object-tree--header" }
const _hoisted_3 = {
  key: 0,
  class: "object-tree--title"
}
const _hoisted_4 = {
  key: 1,
  class: "json-input json-input--container"
}
const _hoisted_5 = { class: "json-input--messages-container" }
const _hoisted_6 = {
  key: 0,
  class: "json-input--message subdue"
}
const _hoisted_7 = {
  key: 1,
  class: "json-input--error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle = _resolveComponent("toggle")!
  const _component_object_tree_node = _resolveComponent("object-tree-node")!
  const _component_ozn_button = _resolveComponent("ozn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {
        preview: _ctx.preview,
        header: _ctx.header
      }, () => [
        (_ctx.header)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_3, _toDisplayString(_ctx.header), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_toggle, {
          modelValue: _ctx.preview,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.preview) = $event)),
          label: "Show JSON"
        }, null, 8, ["modelValue"])
      ], true)
    ]),
    (!_ctx.preview)
      ? (_openBlock(), _createBlock(_component_object_tree_node, {
          modelValue: _ctx.root,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.root) = $event)),
            _ctx.updateRoot
          ],
          suggestions: _ctx.suggestions,
          key: Object.keys(_ctx.root).length
        }, null, 8, ["modelValue", "suggestions", "onUpdate:modelValue"]))
      : (_openBlock(), _createElementBlock("pre", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "json-input--type subdue" }, "JSON", -1)),
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.jsonError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "- valid"))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, "- " + _toDisplayString(_ctx.jsonError), 1))
          ]),
          _createElementVNode("code", {
            class: _normalizeClass(["json-input", {error: !!_ctx.jsonError}]),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dbUpdateRoot && _ctx.dbUpdateRoot(...args))),
            contenteditable: ""
          }, _toDisplayString(_ctx.root), 35)
        ])),
    _createVNode(_component_ozn_button, {
      class: "minimal",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addRootNode()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("+ " + _toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    })
  ]))
}